import {ContentWrapper, PageWrapper, LeftColumnWrapper, RightColumnWrapper} from 'components/wrappers/pages'
import NoDataAndLoading from 'components/NoDataAndLoading'
import {connect} from 'react-redux'
import {Layer, Stage, Rect} from 'react-konva'
import ActionBar from './ActionBar'
import * as actTableManagement from 'actions/tableManagement'
import AddTableModal from './AddTableModal'
import EditTableModal from './EditTableModal'
import {browserHistory} from 'react-router'
import ConfirmActionModal from 'components/ConfirmActionModal'
import LibraryDeleteModal from 'components/LibraryDeleteModal'
import {change} from 'redux-form'
import {askConfirmAction} from 'actions/confirm-action'
import _isEqual from 'lodash/isEqual'
import {push} from 'react-router-redux'
import RestoTable from './RestoTable'
import styles from './TableManagementMap.css'

import {COL_MAX, ROW_MAX, GRID_SIZE} from './constants'

class TableManagementMap extends React.Component {
  state = {
    imageRound: null,
    imageSquare: null,
    color: 'green'
  }

  componentDidMount () {
    const {dispatch} = this.props
    let {groupDetail} = this.props.group

    const {expired} = this.props.subscriptionExpired
    if (!expired) {
      dispatch(actTableManagement.mapPageRequest())
      browserHistory.listenBefore(location => {
        const {tables, originalTables} = this.props.map
        // this is still hacky, don't copy paste this
        if (!_isEqual(tables, originalTables) && !this.props.nextAction) {
          dispatch(askConfirmAction(push(location)))
          return false
        }
      })
    } else {
      browserHistory.push('/settings/billing')
    }

    let {groups} = this.props.group
    if (groupDetail && groupDetail.id || groups.length > 0) {
      let id
      if (groupDetail) {
        id = groupDetail.id
      } else {
        id = groups[0].id
      }
      dispatch(actTableManagement.dropDownSelectTableGroup(id))
    } else {
      dispatch(change('search', 'groupId', 0))
      dispatch(actTableManagement.setTable(null))
      dispatch(actTableManagement.setTables([]))
      dispatch(actTableManagement.setOriginalTables([]))
    }

    const imageRound = new window.Image()
    imageRound.src = require('assets/images/table_circle.png')
    imageRound.onload = () => {
      this.setState({
        imageRound: imageRound
      })
    }

    const imageSquare = new window.Image()
    imageSquare.src = require('assets/images/table_square.png')
    imageSquare.onload = () => {
      this.setState({
        imageSquare: imageSquare
      })
    }
  }

  _renderGrid = () => {
    let grid = []
    for (let i = 0; i < ROW_MAX; i++) {
      for (let j = 0; j < COL_MAX; j++) {
        let xx = j * GRID_SIZE
        let yy = i * GRID_SIZE
        grid.push(
          <Rect
            x={0 + xx} y={0 + yy} zIndex={0}
            width={GRID_SIZE} height={GRID_SIZE}
            fill={j % 2 ? '#eef6ff' : '#fbfbfb'}
            stroke='#e8e8e8' strokeWidth={1}
          />
        )
      }
    }
    return (<Layer ref='layer0'>{grid}</Layer>)
  }

  render () {
    let {showLoadingSpinnerPage} = this.props.loadingSpinner
    let {groups} = this.props.group
    let {showDeleteModal, table, tables} = this.props.map
    let tableName = table ? table.name : ''

    return (<div>
      <PageWrapper>
        <ActionBar />
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={false}>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={groups && groups.length === 0}
              title='No Table Group'
              additionalJsx={<div><button className='btn btn-primary' onClick={this._gotoGroup}>Create Table Group</button></div>}
              description='You cannot add without select Table Group'
            />
            {!showLoadingSpinnerPage && (groups &&
              groups.length > 0 && (<div className={`${styles['table-map-stage']}`}>
                <Stage y={10} width={900} height={700}>
                  {this._renderGrid()}
                  <Layer>
                    {tables && tables.map(_table => {
                      return (
                        <RestoTable
                          table={_table}
                          imageRound={this.state.imageRound}
                          imageSquare={this.state.imageSquare}
                        />
                      )
                    })}
                  </Layer>
                </Stage>
              </div>)
            )}
          </LeftColumnWrapper>
          <RightColumnWrapper />
        </ContentWrapper>
      </PageWrapper>
      <AddTableModal />
      <EditTableModal />

      <LibraryDeleteModal
        showDeleteModal={showDeleteModal}
        onHide={this._onHideModal}
        title='Table'
        name={tableName}
        onDelete={this._onDelete}
      />
      <ConfirmActionModal />
    </div>)
  }

  _onDelete = () => {
    const {dispatch} = this.props
    let {groupDetail} = this.props.group
    let {tables, table, originalTables} = this.props.map
    dispatch(actTableManagement.submitDeleteTable(table, tables, groupDetail, originalTables))
  }

  _onHideModal = () => {
    const {dispatch} = this.props
    dispatch(actTableManagement.setTable(null))
    dispatch(actTableManagement.hideTableMapDeleteModal())
  }

  _gotoGroup () {
    browserHistory.replace('/table-management/group')
  }
}

function mapStateToProps (state) {
  return {
    map: state.tableManagement.map,
    group: state.tableManagement.group,
    loadingSpinner: state.loadingSpinner,
    subscriptionExpired: state.subscriptionExpired,
    nextAction: state.confirmAction.nextAction
  }
}

export default connect(mapStateToProps)(TableManagementMap)



// WEBPACK FOOTER //
// ./app/pages/TableManagement/TableManagementMap/TableManagementMap.js